module.exports = __webpack_public_path__ + "static/media/Lisa.43922f51.png";